// Libraries
import React, { useContext } from 'react';

// Services and Contexts
import LanguageContext from '../../../contexts/LanguageContext';
import QuestionsContext from '../../../contexts/QuestionsContext';

// Material-UI
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import { grey, blue } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  clearButton: {
    color: grey[400],
    marginLeft: theme.spacing(2)
  },
  questionItem: {
    borderBottom: `1px solid ${grey[400]}`,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(4)
  },
  answered: {
    backgroundColor: blue[50]
  }
}));

export default function QuestionItem({ categoryIndex, questionIndex }) {
  const { questions, handleAnswer } = useContext(QuestionsContext);
  const { translate, language } = useContext(LanguageContext);
  const question = questions[categoryIndex].questions[questionIndex];
  const styles = useStyles();

  const questionItemClasses = [styles.questionItem];
  if (question.answer !== undefined) questionItemClasses.push(styles.answered);

  return (
    <Box className={questionItemClasses.join(' ')}>
      <Box paddingRight={3}>
        <Typography variant="body1">{question[language]}</Typography>
      </Box>
      <Box marginTop={1}>
        <ButtonGroup disableRipple disableElevation variant="contained" size="small">
          <Button
            color={question.answer === true ? 'primary' : 'inherit'}
            onClick={() => handleAnswer(categoryIndex, questionIndex, true)}>
            {translate('UI_QUESTION_BUTTON_YES')}
          </Button>
          <Button
            color={question.answer === false ? 'primary' : 'default'}
            onClick={() => handleAnswer(categoryIndex, questionIndex, false)}>
            {translate('UI_QUESTION_BUTTON_NO')}
          </Button>
        </ButtonGroup>
        <Button
          size="small"
          className={styles.clearButton}
          onClick={() => handleAnswer(categoryIndex, questionIndex)}>
          {translate('UI_QUESTION_BUTTON_CLEAR')}
        </Button>
      </Box>
    </Box>
  );
}
